module.exports = __webpack_public_path__ + "img/Add2.6c2f1c8c.svg";